let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("c8CAi")).then(() => parcelRequire('g9ImX'));